
import { useEffect } from "react";
import "./Blog.css"
import Footer from "./Footer";
import Header from "./Header";
import AOS from "aos";
import "aos/dist/aos.css";

const Blog = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);
    return (
        <>
            {/* <!-- Blog Hero Section --> */}
            <Header />
            <section className="blog-hero section-container">
                <div className="hero-background"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>

                <div className="content-container">
                    <div className="hero-content">
                        <h1 className="hero-title" data-aos="fade-up">Ask Jeeves IP Blog</h1>
                        <p className="hero-subtitle" data-aos="fade-up" data-aos-delay="100">Insights on AI-powered patent protection, mobile marketing technology, and intellectual property strategy</p>
                        <div className="hero-tagline" data-aos="fade-up" data-aos-delay="200">
                            <i className="fas fa-lightbulb"></i>
                            Stay Ahead with Cutting-Edge IP Insights
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Blog Content Section --> */}
            <section className="blog-content-section section-container">
                <div className="content-container">
                    <div className="blog-wrapper">
                        {/* <!-- Main Content --> */}
                        <main className="blog-main">
                            {/* <!-- Featured Post --> */}
                            <article className="featured-post" data-aos="fade-up">
                                <div className="featured-badge">
                                    <i className="fas fa-star"></i>
                                    Featured Article
                                </div>
                                <div className="post-image">
                                    <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="AI Patent Technology" />
                                </div>
                                <div className="post-content">
                                    <div className="post-meta">
                                        <span className="post-category">AI & Patents</span>
                                        <span className="post-date">
                                            <i className="far fa-calendar"></i>
                                            November 15, 2023
                                        </span>
                                        <span className="post-read-time">
                                            <i className="far fa-clock"></i>
                                            8 min read
                                        </span>
                                    </div>
                                    <h2 className="post-title">How AI is Revolutionizing Patent Drafting and Protection</h2>
                                    <p className="post-excerpt">Discover how artificial intelligence is transforming the patent industry, making high-quality patent protection faster, more affordable, and accessible to startups and innovators worldwide.</p>
                                    <a href="#ai-patent-article" className="read-more-btn">Read Full Article</a>
                                </div>
                            </article>

                            {/* <!-- Blog Grid --> */}
                            <div className="blog-grid">
                                {/* <!-- Post 1 --> */}
                                <article className="blog-post" data-aos="fade-up" data-aos-delay="100">
                                    <div className="post-image">
                                        <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="TCPA Compliance" />
                                    </div>
                                    <div className="post-content">
                                        <div className="post-meta">
                                            <span className="post-category">Compliance</span>
                                            <span className="post-date">
                                                <i className="far fa-calendar"></i>
                                                November 10, 2023
                                            </span>
                                        </div>
                                        <h3 className="post-title">TCPA Compliance in 2024: What Every Mobile Marketer Needs to Know</h3>
                                        <p className="post-excerpt">Stay ahead of regulatory changes with our comprehensive guide to TCPA compliance for mobile marketing campaigns.</p>
                                        <a href="#tcpa-article" className="read-more-btn">Read More</a>
                                    </div>
                                </article>

                                {/* <!-- Post 2 --> */}
                                <article className="blog-post" data-aos="fade-up" data-aos-delay="200">
                                    <div className="post-image">
                                        <img src="https://images.unsplash.com/photo-1611605698335-8b1569810432?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="SMS Marketing" />
                                    </div>
                                    <div className="post-content">
                                        <div className="post-meta">
                                            <span className="post-category">Mobile Marketing</span>
                                            <span className="post-date">
                                                <i className="far fa-calendar"></i>
                                                November 5, 2023
                                            </span>
                                        </div>
                                        <h3 className="post-title">The Future of SMS Marketing: AI-Powered Personalization at Scale</h3>
                                        <p className="post-excerpt">Learn how AI is enabling hyper-personalized SMS campaigns that deliver unprecedented conversion rates.</p>
                                        <a href="#sms-article" className="read-more-btn">Read More</a>
                                    </div>
                                </article>

                                {/* <!-- Post 3 --> */}
                                <article className="blog-post" data-aos="fade-up" data-aos-delay="300">
                                    <div className="post-image">
                                        <img src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Patent Strategy" />
                                    </div>
                                    <div className="post-content">
                                        <div className="post-meta">
                                            <span className="post-category">IP Strategy</span>
                                            <span className="post-date">
                                                <i className="far fa-calendar"></i>
                                                October 28, 2023
                                            </span>
                                        </div>
                                        <h3 className="post-title">Building a Defensible Patent Portfolio on a Startup Budget</h3>
                                        <p className="post-excerpt">Strategic approaches to patent protection that maximize coverage while minimizing costs for early-stage companies.</p>
                                        <a href="#patent-strategy-article" className="read-more-btn">Read More</a>
                                    </div>
                                </article>

                                {/* <!-- Post 4 --> */}
                                <article className="blog-post" data-aos="fade-up" data-aos-delay="400">
                                    <div className="post-image">
                                        <img src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="QR Code Technology" />
                                    </div>
                                    <div className="post-content">
                                        <div className="post-meta">
                                            <span className="post-category">Technology</span>
                                            <span className="post-date">
                                                <i className="far fa-calendar"></i>
                                                October 20, 2023
                                            </span>
                                        </div>
                                        <h3 className="post-title">Beyond the Scan: How Smart QR Codes are Transforming Customer Engagement</h3>
                                        <p className="post-excerpt">Explore the next generation of QR code technology and its applications in modern marketing campaigns.</p>
                                        <a href="#qr-article" className="read-more-btn">Read More</a>
                                    </div>
                                </article>

                                {/* <!-- Post 5 --> */}
                                <article className="blog-post" data-aos="fade-up" data-aos-delay="500">
                                    <div className="post-image">
                                        <img src="https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="ROI Analytics" />
                                    </div>
                                    <div className="post-content">
                                        <div className="post-meta">
                                            <span className="post-category">Analytics</span>
                                            <span className="post-date">
                                                <i className="far fa-calendar"></i>
                                                October 15, 2023
                                            </span>
                                        </div>
                                        <h3 className="post-title">Measuring Mobile Marketing ROI: Advanced Analytics for Campaign Optimization</h3>
                                        <p className="post-excerpt">Advanced techniques for tracking and optimizing the return on investment from your mobile marketing campaigns.</p>
                                        <a href="#roi-article" className="read-more-btn">Read More</a>
                                    </div>
                                </article>

                                {/* <!-- Post 6 --> */}
                                <article className="blog-post" data-aos="fade-up" data-aos-delay="600">
                                    <div className="post-image">
                                        <img src="https://images.unsplash.com/photo-1552664688-cf412ec27db2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Marketing Automation" />
                                    </div>
                                    <div className="post-content">
                                        <div className="post-meta">
                                            <span className="post-category">Automation</span>
                                            <span className="post-date">
                                                <i className="far fa-calendar"></i>
                                                October 10, 2023
                                            </span>
                                        </div>
                                        <h3 className="post-title">Marketing Automation Workflows That Actually Convert</h3>
                                        <p className="post-excerpt">Building intelligent automation sequences that guide customers through the sales funnel with minimal manual intervention.</p>
                                        <a href="#automation-article" className="read-more-btn">Read More</a>
                                    </div>
                                </article>
                            </div>

                            {/* <!-- Pagination --> */}
                            <div className="pagination" data-aos="fade-up">
                                <a href="#" className="page-link active">1</a>
                                <a href="#" className="page-link">2</a>
                                <a href="#" className="page-link">3</a>
                                <a href="#" className="page-link">
                                    <i className="fas fa-chevron-right"></i>
                                </a>
                            </div>
                        </main>

                        {/* <!-- Sidebar --> */}
                        <aside className="blog-sidebar">
                            {/* <!-- Search --> */}
                            <div className="sidebar-widget search-widget" data-aos="fade-left">
                                <h3 className="widget-title">Search Articles</h3>
                                <form className="search-form" id="searchForm">
                                    <input type="text" placeholder="Search articles..." className="search-input" id="searchInput" />
                                    <button type="submit" className="search-btn">
                                        <i className="fas fa-search"></i>
                                    </button>
                                </form>
                            </div>

                            {/* <!-- Categories --> */}
                            <div className="sidebar-widget categories-widget" data-aos="fade-left" data-aos-delay="100">
                                <h3 className="widget-title">Categories</h3>
                                <ul className="categories-list">
                                    <li><a href="#" className="category-link active" data-category="all">All Articles</a></li>
                                    <li><a href="#" className="category-link" data-category="AI & Patents">AI & Patents <span className="category-count">12</span></a></li>
                                    <li><a href="#" className="category-link" data-category="Mobile Marketing">Mobile Marketing <span className="category-count">8</span></a></li>
                                    <li><a href="#" className="category-link" data-category="Compliance">TCPA Compliance <span className="category-count">6</span></a></li>
                                    <li><a href="#" className="category-link" data-category="Technology">Technology <span className="category-count">10</span></a></li>
                                    <li><a href="#" className="category-link" data-category="IP Strategy">IP Strategy <span className="category-count">7</span></a></li>
                                    <li><a href="#" className="category-link" data-category="Analytics">Analytics <span className="category-count">5</span></a></li>
                                </ul>
                            </div>

                            {/* <!-- Popular Posts --> */}
                            <div className="sidebar-widget popular-widget" data-aos="fade-left" data-aos-delay="200">
                                <h3 className="widget-title">Popular Articles</h3>
                                <div className="popular-posts">
                                    <article className="popular-post">
                                        <div className="popular-image">
                                            <img src="https://images.unsplash.com/photo-1535223289827-42f1e9919769?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80" alt="Popular Article" />
                                        </div>
                                        <div className="popular-content">
                                            <h4><a href="#">How Our Patented Technology Powers Mobile Advertising</a></h4>
                                            <div className="popular-meta">
                                                <span>Oct 25, 2023</span>
                                                <span>•</span>
                                                <span>5 min read</span>
                                            </div>
                                        </div>
                                    </article>

                                    <article className="popular-post">
                                        <div className="popular-image">
                                            <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80" alt="Popular Article" />
                                        </div>
                                        <div className="popular-content">
                                            <h4><a href="#">AI vs. Attorneys: The Future of Patent Protection</a></h4>
                                            <div className="popular-meta">
                                                <span>Oct 18, 2023</span>
                                                <span>•</span>
                                                <span>7 min read</span>
                                            </div>
                                        </div>
                                    </article>

                                    <article className="popular-post">
                                        <div className="popular-image">
                                            <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80" alt="Popular Article" />
                                        </div>
                                        <div className="popular-content">
                                            <h4><a href="#">Text Messaging Compliance: Avoiding Costly Mistakes</a></h4>
                                            <div className="popular-meta">
                                                <span>Oct 10, 2023</span>
                                                <span>•</span>
                                                <span>6 min read</span>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            </div>

                            {/* <!-- Newsletter --> */}
                            <div className="sidebar-widget newsletter-widget" data-aos="fade-left" data-aos-delay="300">
                                <h3 className="widget-title">Stay Updated</h3>
                                <p>Get the latest insights on AI patent technology and mobile marketing delivered to your inbox.</p>
                                <form className="newsletter-form" id="sidebarNewsletterForm">
                                    <input type="email" placeholder="Your email address" className="newsletter-input" id="sidebarEmail" required />
                                    <button type="submit" className="newsletter-btn">
                                        <i className="fas fa-paper-plane"></i>
                                        Subscribe
                                    </button>
                                </form>
                                <p className="newsletter-note">No spam. Unsubscribe anytime.</p>
                            </div>

                            {/* <!-- Tags --> */}
                            <div className="sidebar-widget tags-widget" data-aos="fade-left" data-aos-delay="400">
                                <h3 className="widget-title">Popular Tags</h3>
                                <div className="tags-container">
                                    <a href="#" className="tag">AI Patents</a>
                                    <a href="#" className="tag">TCPA</a>
                                    <a href="#" className="tag">SMS Marketing</a>
                                    <a href="#" className="tag">Mobile Ads</a>
                                    <a href="#" className="tag">QR Codes</a>
                                    <a href="#" className="tag">Compliance</a>
                                    <a href="#" className="tag">Patent Strategy</a>
                                    <a href="#" className="tag">Marketing Automation</a>
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>
            </section>
            {/* <!-- Newsletter Section --> */}
            <section className="blog-newsletter-section section-container">
                <div className="content-container">
                    <div className="newsletter-content" data-aos="fade-up">
                        <div className="newsletter-icon">
                            <i className="fas fa-envelope-open-text"></i>
                        </div>
                        <h2 className="newsletter-title">Never Miss an Update</h2>
                        <p className="newsletter-text">Subscribe to our newsletter for exclusive insights on AI-powered patent protection and mobile marketing technology.</p>
                        <form className="newsletter-main-form" id="mainNewsletterForm">
                            <input type="email" placeholder="Enter your email address" className="newsletter-main-input" id="mainEmail" required />
                            <button type="submit" className="newsletter-main-btn">Subscribe Now</button>
                        </form>
                        <p className="newsletter-note">Join 5,000+ innovators who receive our weekly insights</p>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default Blog;